import {
    AceClubs,
    AceDiamonds,
    AceHearts,
    AceSpades,
    EightClubs,
    EightDiamonds,
    EightHearts,
    EightSpades,
    FiveClubs,
    FiveDiamonds,
    FiveHearts,
    FiveSpades,
    FourClubs,
    FourDiamonds,
    FourHearts,
    FourSpades,
    JackClubs,
    JackDiamonds,
    JackHearts,
    JackSpades,
    KingClubs,
    KingDiamonds,
    KingHearts,
    KingSpades,
    NineClubs,
    NineDiamonds,
    NineHearts,
    NineSpades,
    QueenClubs,
    QueenDiamonds,
    QueenHearts,
    QueenSpades,
    SevenClubs,
    SevenDiamonds,
    SevenHearts,
    SevenSpades,
    SixClubs,
    SixDiamonds,
    SixHearts,
    SixSpades,
    TenClubs,
    TenDiamonds,
    TenHearts,
    TenSpades,
    ThreeClubs,
    ThreeDiamonds,
    ThreeHearts,
    ThreeSpades,
    TwoClubs,
    TwoDiamonds,
    TwoHearts,
    TwoSpades
} from "./cards";

export const cardMapping: { [cardName: string]: JSX.Element } = {
  "2C": <TwoClubs />,
  "2D": <TwoDiamonds />,
  "2H": <TwoHearts />,
  "2S": <TwoSpades />,
  "3C": <ThreeClubs />,
  "3D": <ThreeDiamonds />,
  "3H": <ThreeHearts />,
  "3S": <ThreeSpades />,
  "4C": <FourClubs />,
  "4D": <FourDiamonds />,
  "4H": <FourHearts />,
  "4S": <FourSpades />,
  "5C": <FiveClubs />,
  "5D": <FiveDiamonds />,
  "5H": <FiveHearts />,
  "5S": <FiveSpades />,
  "6C": <SixClubs />,
  "6D": <SixDiamonds />,
  "6H": <SixHearts />,
  "6S": <SixSpades />,
  "7C": <SevenClubs />,
  "7D": <SevenDiamonds />,
  "7H": <SevenHearts />,
  "7S": <SevenSpades />,
  "8C": <EightClubs />,
  "8D": <EightDiamonds />,
  "8H": <EightHearts />,
  "8S": <EightSpades />,
  "9C": <NineClubs />,
  "9D": <NineDiamonds />,
  "9H": <NineHearts />,
  "9S": <NineSpades />,
  "10C": <TenClubs />,
  "10D": <TenDiamonds />,
  "10H": <TenHearts />,
  "10S": <TenSpades />,
  "11C": <JackClubs />,
  "11D": <JackDiamonds />,
  "11H": <JackHearts />,
  "11S": <JackSpades />,
  "12C": <QueenClubs />,
  "12D": <QueenDiamonds />,
  "12H": <QueenHearts />,
  "12S": <QueenSpades />,
  "13C": <KingClubs />,
  "13D": <KingDiamonds />,
  "13H": <KingHearts />,
  "13S": <KingSpades />,
  "14C": <AceClubs />,
  "14D": <AceDiamonds />,
  "14H": <AceHearts />,
  "14S": <AceSpades />,
};
